// extracted by mini-css-extract-plugin
export default {"container":"container___Lu9CJ","icon":"icon___HoE7d","label":"label___ev5J8"};